module.exports = __webpack_public_path__ + "static/feature1-369e0463f62f2acfbd1e8e33ff25e75b.png";